<template>
	<div class="animated fadeIn">
		<!-- Component -->
		<div class="pt-3 pr-3 pb-0 pl-3">
			<OverviewCard
				name="Commands"
				:link="serviceLink"
				:keywords="keywords"
				:search="search"
				@keywordsChange="setKeywords"
			>
				<p class="h4">{{ $t('Commands list') }}</p>
				<table class="table table-bordered table-striped table-sm">
					<thead>
						<tr>
							<th v-for="col in columns">{{ $t(col) }}</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="record in records">
							<td v-for="element in record">
								<span v-if="element.action == 'delete'" @click="delete_it(element, true)">
									<i class="fa fa-remove fa-lg"></i>
								</span>
								<span v-if="element.action == 'edit'">
									<router-link v-if="element.link" v-bind:to="element.href">
										<i class="fa fa-edit fa-lg"></i>
									</router-link>
								</span>
								<span v-if="element.action == 'status'">
									<c-switch
										@change="set_status(element)"
										type="icon"
										size="sm"
										variant="success"
										v-bind="{on: '\uf00c', off: '\uf00d'}"
										:pill="true"
										:checked="element.text"
									/>
								</span>
								<span v-if="element.action == 'txt'">{{ element.text }}</span>
							</td>
						</tr>
						<tr v-if="!records.length" v-cloak>
							<td colspan="4">
								<div class="text-center">{{ $t('no data') }}</div>
							</td>
						</tr>
					</tbody>
				</table>
				<nav>
					<ul class="pagination">
						<li v-for="pg in pagination_bar" class="page-item" v-bind:class="{active: pg.activate}">
							<span class="page-link" @click="paginate_to(pg.btn)">{{ pg.btn }}</span>
						</li>
					</ul>
				</nav>
				<hr />

				<div class="card">
					<div class="card-header">
						<p class="m-0 h4">{{ $t('Examples list') }}</p>
					</div>

					<ul class="list-group">
						<li
							class="list-group-item"
							v-for="example in examples"
							:key="`exampled-${example._id}`"
							:class="example.example_lang === 'arabic'? 'text-right' : 'text-left'"
						>{{ example.example_text }}</li>
					</ul>

					<div class="card-footer">
						<a target="_blank" :href="serviceExamplesURL">Download Examples</a>
					</div>
				</div>

				<p class="h4">{{ $t('Clone Command') }}</p>
				<tooltip label="Clone command" class="mb-0">
					<b-form-group class="mb-0">
						<b-input-group>
							<b-input-group-prepend>
								<b-button @click="clone_command" variant="primary">
									<i class="fa fa-clone"></i>
									{{ $t('Clone') }}
								</b-button>
							</b-input-group-prepend>
							<select class="form-control" v-model="clone_command_id">
								<option value="0">{{ $t('None') }}</option>
								<option
									v-for="command in clone_commands"
									:value="command.command_id"
								>{{ command.command_name }}</option>
							</select>
						</b-input-group>
					</b-form-group>
				</tooltip>
			</OverviewCard>
			<!-- /.col -->
		</div>
		<!-- /.row -->
		<b-modal
			title="Modal title"
			class="modal-primary"
			v-model="deleteModal"
			@ok="delete_it(0, false)"
		>{{ $t('Do you really need to delete') }} {{ active_element_name }} ?</b-modal>
	</div>
</template>

<script>
	import axios from 'axios'

	import {cSwitch, OverviewCard} from '../../components'
	import searchMixins from '../../mixins/search'

	export default {
		name: 'CommandList',
		components: {
			cSwitch,
			OverviewCard,
		},
		mixins: [searchMixins],
		computed: {
			serviceLink() {
				return '/services/' + this.service_id + '/commands/0'
			},
		},
		data() {
			return {
				records: [],
				examples: [],
				columns: [],
				service_id: 0,
				page: 1,
				pagination_bar: [],
				keywords: '',
				deleteModal: false,
				active_element_id: 0,
				active_element_name: '',
				clone_command_id: 0,
				clone_commands: [],
				serviceExamplesURL: '',
			}
		},
		methods: {
			clone_command() {
				if (!parseInt(this.clone_command_id) > 0) return false
				this.$root.loader = true
				axios.post('/command/clone/' + this.service_id + '/' + this.clone_command_id).then((response) => {
					this.$root.loader = false
					if (response.data.status == 1) {
						this.push_record(response.data.data)
						this.clone_commands.push(response.data.data)
						this.$root.notify({
							message: this.$t('successfully cloned'),
							status: 'success',
							area: 'topRight',
						})
						this.$store.commit('add_go_commands', {
							command_id: response.data.data.command_id,
							command_name: response.data.data.command_name,
						})
					} else {
						this.$root.notify({
							message: this.$t('server error'),
							status: 'error',
							autoHide: false,
							area: 'topRight',
						})
					}
				})
			},
			paginate_to(page_no) {
				this.records = []
				this.pagination_bar = []
				this.$root.loader = true
				this.page = page_no
				axios
					.post('/command/get/' + this.service_id + '/' + page_no, {keywords: this.keywords})
					.then((response) => {
						if (response.data.status == 1) {
							this.page = parseInt(response.data.page)
							for (var i = 0; i < parseInt(response.data.pages_count); i++) {
								var acti_ = false
								if (this.page === i + 1) {
									acti_ = true
								} else {
									acti_ = false
								}
								this.pagination_bar.push({
									btn: (i + 1).toString(),
									activate: acti_,
								})
							}
							for (var i = 0; i < response.data.data.length; i++) {
								this.push_record(response.data.data[i])
							}
							this.$root.loader = false
						} else {
							this.$root.loader = false
						}
					})
			},

			push_record(record) {
				var status = parseInt(record['command_status']) == 1 ? true : false
				this.records.push([
					{text: record['command_name'], link: false, action: 'txt', id: record['command_id']},
					{text: status, link: false, action: 'status', id: record['command_id']},
					{
						text: '',
						link: true,
						href: '/services/' + this.service_id + '/commands/' + record['command_id'],
						action: 'edit',
					},
					{
						text: record['command_name'],
						link: false,
						action: 'delete',
						id: record['command_id'],
					},
				])
			},

			search() {
				this.paginate_to(1)
			},

			set_status(element) {
				var status = 1
				if (element.text == false) {
					status = 1 // reverse the current status
				} else {
					status = 0
				}
				axios.post('/command/set_status/' + element.id, {status: status}).then((response) => {
					if (response.data.status == 1) {
					}
				})
			},
			delete_it(element, alarm) {
				if (alarm) {
					this.deleteModal = true
					this.active_element_id = element.id
					this.active_element_name = element.text
				} else {
					if (this.active_element_id > 0) {
						this.$root.loader = true
						axios.post('/command/delete/' + this.active_element_id, {}).then((response) => {
							if (response.data.status == 1) {
								this.deleteModal = false
								this.paginate_to(this.page)
								this.$store.commit('delete_go_commands', this.active_element_id)
								this.clone_command_id = 0
								this.clone_commands = this.clone_commands.reduce(
									function(a, b) {
										return a.concat(b.command_id === this.active_element_id ? [] : b)
									}.bind(this),
									[]
								)
							}
						})
					}
				}
			},

			async getAllServiceExamples() {
				try {
					const {data} = await axios.get(`service/${this.service_id}/examples`)

					this.examples = data.examples

					this.serviceExamplesURL = `${process.env.VUE_APP_SERVER_URL}/service/${this.service_id}/examples?type=file`
				} catch (error) {
					console.log(error)
				}
			},
		},
		mounted() {
			if (parseInt(this.$route.params.page) >= 1) {
				this.page = parseInt(this.$route.params.page)
			} else {
				this.page = 1
			}

			if (parseInt(this.$route.params.service_id) >= 1) {
				this.service_id = parseInt(this.$route.params.service_id)
			}
			this.$store.commit('set_go_services_id', parseInt(this.$route.params.service_id))
			this.columns = ['Name', 'Status', 'Edit', 'Delete']
			this.paginate_to(this.page)

			axios.get('/command/get_all').then((response) => {
				if (response.data.status == 1) {
					this.clone_commands = response.data.data
				}
			})

			if (this.service_id) {
				this.getAllServiceExamples()
			}
		},
	}
</script>
